import React from "react";
import Layout from "../components/ui/Layout";
import ContactInfo from "../components/ContactInfo";
import ContactForm from "../features/Contact";

export default function Contact() {
  return(
    <section className="w-full h-screen z-10">
      <Layout>
        <div className="mt-24 mb-12">
          <ContactInfo />
          <ContactForm contactTheme="light" />
        </div>
      </Layout>
    </section>
  )
}